<template>
    <div id="newsunlamp" class="main">
        <header class="clearfix" :class="{'header_en':version==1}">
            <div class="header_left box">
                <router-link to="/home" tag="div" class="components_logo">
                    <!-- <img src="./img/home/logo.png""> -->
                    <img src="./img/homepage.png"">
                </router-link>
            </div>
            <div class="header box" v-if="titleType == 'span'">
                <span class="notice_title">{{labelData.noticeTitle}}:</span>
                <div id="noticeBox" class="noticeBox" :class="{'notice_title_width':version == 1}">
                    <div class="notice" v-for="(item,index) in noticeList" :style="{top:x*(-22)+'px'}">{{item}}</div>
                </div>
            </div>
            <div class="header box" v-if="titleType == 'select'">
                <el-cascader
                :disabled="!lampEdit || loadingGetMap"
                expand-trigger="hover"
                :options="companyList"
                v-loading="companyListLoading"
                element-loading-background="rgba(55, 59, 68, 0.6)"
                :show-all-levels="false"
                :props="props"
                @change="handleChange"
                v-model="projects">
            </el-cascader>
        </div>
        <div class="header_img_box box clearfix">
            <div class="user_information">
                <router-link to="/userManagement" tag="span" class="span1">
                    {{realname}}
                </router-link>
                <span class="span2">{{role}}</span>
            </div>
            <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <div>
                <span style="line-height:28px;">{{realname}}</span>
                <el-button type="warning" size="mini" style="float:right;" @click="logout()">{{labelData.logout}}</el-button>
            </div>
            <router-link to="/userManagement" tag="el-button" slot="reference" class="user_image_div">
                <img class="user_image" :src="avatar" @error="imgError()"/>
            </router-link>
        </el-popover>
    </div>
</header>
<div class="main_cont scroll_show">
    <router-view></router-view>
</div>
</div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import allUrl from './api/allUel.js'
    import baseApi from './api/base.js'
    import { Notification } from 'element-ui';
    import avatar from './img/userManagement/avatar.png';
    export default{
        name: 'newsunlamp',
        data(){
            return{
                labelData:{
                    noticeTitle:'公告',
                    logout:'退出'
                },
                notice:'',
                noticeList:[],
                titleType:'span',
                projects: [0],
                company_id:'',
                projects_id:'0',
                props:{
                    value:'id',
                    label:'name',
                    children:'projects',
                },
                companyList:[],
                scroll_time:null,
                scroll_time21:null,
                noticeTime:null,
                noticeXTime:null,
                x:0,
                companyListLoading:false,
            }
        },
        props:['url'],
        computed:{
            ...mapGetters({
                linkTo:'linkTo',
                company:'company',
                realname:'realname',
                role:'role',
                avatar:'avatar',
                token:'token',
                client_key:'client_key',
                username:'username',
                projectsId:'projectsId',
                companyId:'companyId',
                lampEdit:'lampEdit',
                version:'version',
                loadingGetMap:'loadingGetMap',
            })
        },
        created(){
        },
        mounted(){
            // require()
            var storage = window.localStorage;
            var url = window.location.hash.split("?")[1]; //获取url中"?"符后的字串
            var theRequest = new Object();
            var str1 = window.location.href.split("/")[2];
            var str2 = document.location.protocol;
            if (url) {
                let arr = url.split("&");
                for (var i = 0; i < arr.length; i++) {
                    theRequest[arr[i].split("=")[0]] = decodeURIComponent(arr[i].split("=")[1]);
                }
                console.log(theRequest,'------------')

                if(str1 == 'localhost:8080' || str1 == '127.0.0.1:8080'){
            // str1 = 'newtest.solar-iot.com'
            // str1 = 'www.solar_copy.com';
            str1 = 'www.roadsmart.cn';
            str2 = 'http:';
            }
            if(theRequest.username&&theRequest.password){
                baseApi.ajax_post(
                    str2+'//'+str1+'/api/login/verify',
                    {
                        username:theRequest.username,
                        password:theRequest.password,
                        client_key:theRequest.client_key,
                        version:theRequest.version,
                    },
                    {},
                    data =>{
                        // console.log(data)
                        data.data.client_key = theRequest.client_key;
                        data.data.username = theRequest.username;
                        data.data.version = theRequest.version;
                        if(data.data.version != '0' && data.data.version != '1'){
                            data.data.version = '0';
                        }
                        storage.setItem('UserInformation',JSON.stringify(data));
                        storage.setItem('rememberPassword','false');
                        storage.setItem('loginState','false');
                        storage.setItem('projectId','false');
                        storage.setItem('companyId','false');

                        var UserInformation = data.data;
                        this.$store.commit('setUserInformation',{
                            company:UserInformation.company,
                            realname:UserInformation.realname,
                            role:UserInformation.role,
                            avatar:UserInformation.avatar,
                            token:UserInformation.token,
                            client_key:UserInformation.client_key,
                            username:UserInformation.username,
                            version:UserInformation.version,
                            privilege:UserInformation.privilege,
                        })
                        window.location.href='#/';
                        fundsd(this,UserInformation);
                    },
                    this,
                    data =>{
                        storage.setItem('loginState','false');
                        window.location.href='login.html';
                        }
                    )
                }else{
                    console.log(storage.getItem("UserInformation"))
                    if(storage.getItem("UserInformation") != 'false' && storage.getItem("UserInformation")){
                        var UserInformation = JSON.parse(storage.getItem("UserInformation")).data;
                        if(JSON.parse(storage.getItem("UserInformation")).data){
                            fundsd(this,UserInformation);
                        }else{
                            storage.setItem('loginState','false');
                            window.location.href='login.html';
                        }
                    }else{
                        storage.setItem('loginState','false');
                        window.location.href='login.html';
                    }
                }
            }else{
                console.log(storage.getItem("UserInformation"))
                if(storage.getItem("UserInformation") != 'false' && storage.getItem("UserInformation")){
                    var UserInformation = JSON.parse(storage.getItem("UserInformation")).data;
                    fundsd(this,UserInformation);
                }else{
                    storage.setItem('loginState','false');
                    window.location.href='login.html';
                }
            }
            function fundsd(this_,UserInformation){
                baseApi.ajax_post3(
                    allUrl.home.homeData,
                    {
                        username:UserInformation.username,
                        client_key:UserInformation.client_key,
                        token:UserInformation.token,
                        version:UserInformation.version,
                    },
                    {},
                    data =>{
                        // console.log(data)
                        // this.homeData = data.data;
                        this_.$store.commit('setHomeData',{
                            homeData:data.data,
                        })
                    },
                this_)

                baseApi.ajax_post3(
                    allUrl.home.homeWeb_info,
                    {
                        username:UserInformation.username,
                        client_key:UserInformation.client_key,
                        token:UserInformation.token,
                        version:UserInformation.version,
                    },
                    {},
                    data =>{
                        // console.log(data)
                        data.data.list.push(data.data.list[0])
                        this_.noticeList = data.data.list;
                        // console.log(this.noticeList)
                        this_.$store.commit('setRecord',{
                            record:data.data.record,
                        })
                        if(data.data.name){
                            document.title = data.data.name;
                        }else{
                            document.title = '智能路灯系统';
                        }
                    },
                this_)
                this_.linkToFun(UserInformation.version);

                if(UserInformation.version == 0){
                    this_.labelData.noticeTitle = '公告';
                    this_.labelData.logout = '退出';
                    if(UserInformation.role == 1){
                        UserInformation.role = '超级管理员';
                    }else if(UserInformation.role == 2){
                        UserInformation.role = '公司管理员';
                    }else if(UserInformation.role == 3){
                        UserInformation.role = '公司客户';
                    }
                }else{
                    this_.labelData.noticeTitle = 'Notice';
                    this_.labelData.logout = 'Sign out';
                    if(UserInformation.role == 1){
                        UserInformation.role = 'Super administrator';
                    }else if(UserInformation.role == 2){
                        UserInformation.role = 'Company administrator';
                    }else if(UserInformation.role == 3){
                        UserInformation.role = 'Company Sub administrator';
                    }
                }
                this_.$store.commit('setUserInformation',{
                    company:UserInformation.company,
                    realname:UserInformation.realname,
                    role:UserInformation.role,
                    avatar:UserInformation.avatar,
                    token:UserInformation.token,
                    client_key:UserInformation.client_key,
                    username:UserInformation.username,
                    version:UserInformation.version,
                    privilege:UserInformation.privilege,
                })
            }
            let this_ = this;

            let linkTypeArr =  window.location.href.split("/");
            let linkType = linkTypeArr[linkTypeArr.length-1];
            console.log(linkType,'-------------')
            if(linkType == 'projectSummary'){
                this.titleType = 'select';
                this.companyListLoading = true;
                baseApi.ajax_post(
                    allUrl.home.companyList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data =>{
                        this.companyListLoading = false;
                        this.companyList = data.data;
            // console.log(version,'------------------')
            if(UserInformation.version == 0){
                this.companyList.splice(0,0,{
                    id:0,
                    name:'全部项目'})
            }else{
                this.companyList.splice(0,0,{
                    id:0,
                    name:'All projects'})
            }
            // console.log(data,'项目列表')
            },
            this,data=>{
                this.companyListLoading = false;
            })
            }
            if(linkType == ''){
                let time = setInterval(function(){
                    if(document.getElementsByClassName('header_img_box')[0]){
            // document.getElementsByClassName('header_img_box')[0].className = 'header_right box';
            clearInterval(time)
            }else if(document.getElementsByClassName('header_right')[0]){
                clearInterval(time)
            }
            },10)
                let time1 = setInterval(function(){
                    if(document.getElementsByClassName('header')[0]){
            // document.getElementsByClassName('header')[0].className = 'header_centre box';
            clearInterval(time1)
            }else if(document.getElementsByClassName('header_centre')[0]){
                clearInterval(time1)
            }
            },10)
            }else{
                let time = setInterval(function(){
                    if(document.getElementsByClassName('header_right')[0]){
                        document.getElementsByClassName('header_right')[0].className = 'header_img_box box';
                        clearInterval(time)
                    }else if(document.getElementsByClassName('header_img_box')[0]){
                        clearInterval(time)
                    }
                },10)
                let time1 = setInterval(function(){
                    if(document.getElementsByClassName('header_centre')[0]){
                        document.getElementsByClassName('header_centre')[0].className = 'header box';
                        clearInterval(time1)
                    }else if(document.getElementsByClassName('header')[0]){
                        clearInterval(time1)
                    }
                },10)
            }

            document.onvisibilitychange=function(){
                if(document.visibilityState=="visible"){
                    this_.noticeTime = setInterval(function(){
                        this_.x++;
                        this_.notice = this_.noticeList[this_.x];
                        if(this_.x == 1){
                            this_.$nextTick(function(){
                                $('.notice').css('transition','all 1s');
                            })
                        }
                        if(this_.x == this_.noticeList.length){
                            this_.$nextTick(function(){
                                $('.notice').css('transition','all 0s');
                            })
                            this_.x = 0;
                        }
                    },4000)
                }else{
                    clearInterval(this_.noticeTime);
                }
            }
        },
    methods:{
        scrollShow(e){
            $(e.target).addClass('scroll_show');
            clearTimeout(this.scroll_time)
            this.scroll_time =setTimeout(function(){
            // console.log(e.target.className)
            $('.scroll_show').removeClass('scroll_show');
            },2000)
            },
            handleChange(val){
            // console.log(val,'3-----------------')
            if(val[1]){
                this.projects_id = val[1];
                this.company_id = val[0];
            }else{
                this.projects_id = 0;
                this.company_id = 0;
            }
        },
        logout(){
            baseApi.ajax_post(
                allUrl.home.logout,
                {
                    username:this.username,
                    client_key:this.client_key,
                    token:this.token,
                },
                {},
                data =>{
                    // console.log(data,'退出登录回调')
                    var storage = window.localStorage;
                    storage.setItem('loginState','false');
                    storage.setItem('UserInformation','false');
                    storage.setItem('version',this.version);
                    window.location.href='login.html';
                },
            this)
        },
        imgError(){
            document.getElementsByClassName("user_image")[0].setAttribute("src",avatar);
        },
        linkToFun(version){
            let this_ = this;
            var storage = window.localStorage;
            // console.log(storage.getItem('projectId'),storage.getItem('companyId'),'----[----------')
            if(storage.getItem('projectId') != 'false' && storage.getItem('projectId')){
                this.projects_id = storage.getItem('projectId');
                this.company_id =  storage.getItem('companyId');
            }else{
                this.projects_id = 0;
                this.company_id = 0
            }

            clearTimeout(this.scroll_time21);
            this.scroll_time21 = setTimeout(function(){
                $(".scroll_show").scroll(function(e) {
                    this_.scrollShow(e)
                });
                $(".el-table__body-wrapper").scroll(function(e) {
                    this_.scrollShow(e)
                });
            },3000)

            /*GIS*/
            this.$store.commit('setLampEdit',{
                lampEdit:true,
            })
            this.$store.commit('setLoadingGetMap',{
                loadingGetMap:false,
            })
            Notification.closeAll();

            var curVal = this.linkTo;
            if(curVal == '/projectSummary'&&this.username){
                this.titleType = 'select';
                console.log(this.username)
                this.companyListLoading = true;
                baseApi.ajax_post(
                    allUrl.home.companyList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data =>{
                        this.companyListLoading = false;
                        this.companyList = data.data;
            // console.log(version,'------------------')
            if(this.version == 0){
                this.companyList.splice(0,0,{
                    id:0,
                    name:'全部项目'})
            }else{
                this.companyList.splice(0,0,{
                    id:0,
                    name:'All projects'})
            }
            // console.log(data,'项目列表')
            },
            this,data=>{
                this.companyListLoading = false;
            })
            }else{
                this.titleType = 'span'
            }
            if(curVal == '/'){
                var time = setInterval(function(){
                    if(document.getElementsByClassName('header_img_box')[0]){
            // document.getElementsByClassName('header_img_box')[0].className = 'header_right box';
            clearInterval(time)
            }else if(document.getElementsByClassName('header_right')[0]){
                clearInterval(time)
            }
            },10)
            }else{
                var time = setInterval(function(){
                    if(document.getElementsByClassName('header_right')[0]){
                        document.getElementsByClassName('header_right')[0].className = 'header_img_box box';
                        clearInterval(time)
                    }else if(document.getElementsByClassName('header_img_box')[0]){
                        clearInterval(time)
                    }
                },10)
            }
        }
    },
    watch:{
        projects_id(curVal,oldVal){
            // this.projects_id = curVal;
            this.$store.commit('setProjectsId',{
                projectsId:this.projects_id,
                companyId:this.company_id
            })
            var storage = window.localStorage;
            if(this.projects_id == 0){
                storage.setItem('projectId',false);
                storage.setItem('companyId',false);
            }else{
                storage.setItem('projectId',this.projects_id);
                storage.setItem('companyId',this.company_id);
            }
            // console.log(this.projects_id,this.company_id,'4-------------')
        },
        projectsId(curVal,oldVal){
            this.projects_id = curVal;
            this.projects = [this.companyId,curVal];
            this.company_id = this.companyId;
            this.projects_id = curVal;
        // console.log(curVal,this.companyId,'2---------------')
        },
        linkTo(curVal,oldVal){
            this.linkToFun(this.version);
        // console.log(curVal,oldVal);
        },
        noticeList(curVal,oldVal){
            let this_ = this;
            this.notice = curVal[this.x];

            clearInterval(this.noticeTime);
            this.noticeTime = setInterval(function(){
                this_.x++;
                this_.notice = curVal[this_.x];
                if(this_.x == 1){
                    this_.$nextTick(function(){
                        $('.notice').css('transition','all 1s');
                    })
                }
                if(this_.x == curVal.length){
                    this_.$nextTick(function(){
                        $('.notice').css('transition','all 0s');
                    })
                    this_.x = 0;
                }
            },4000)
        },
    }
}
</script>

<style type="text/css" lang="less">
.clearfix:after {
    clear: both;
    content: " ";
    display: block;
    height: 0;
    overflow: hidden;
    visibility: hidden;
}
p,h1,ul,li{
    margin: 0px;
    padding: 0px;
}
li{
    list-style:none;
}
.is_disabled{
    cursor: not-allowed !important;
}
/*弹框样式*/
.el-dialog__header{
    border-bottom: 1px solid #E8E8E8;
    span{
        color: #444444; 
    }
}
.el-dialog__headerbtn {
    top: 13px;
    font-size: 30px;
}
.el-dialog__body{
    .dialog_foot{
        text-align:center;padding: 60px 0 20px 0;
        .el-button{
            width:320px;
            height:60px;
            border-radius: 6px;
            font-size:16px;
        }
    }
}
html,body{height:100%}
body{
// width: 1920px;
// background: #edeef1;
margin: 0px;
padding: 0px;
::-webkit-scrollbar-button{
    width: 10px;
    height: 10px;
}
::-webkit-scrollbar {/*滚动条整体样式*/
    width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
}
::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
// -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
// background: #D8D8D8;
}
::-webkit-scrollbar-track {/*滚动条里面轨道*/
// -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
// border-radius: 10px;
// background: #EDEDED;
}
.el-table__body-wrapper::-webkit-scrollbar-button {/*滚动条整体样式*/
    width: 0px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 0px;
}
.el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
    width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 0px;
// -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
// background: #D8D8D8;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb:horizontal{
    background: #D8D8D8;
}
.scroll_show::-webkit-scrollbar-thumb {
    background: #D8D8D8;
}
.scroll_show_all::-webkit-scrollbar-thumb {
    background: #D8D8D8;
}
.el-cascader-menu::-webkit-scrollbar-thumb {
    background: #D8D8D8;
}
/*级联框*/
.el-cascader-menu__item--extensible:after{
    display:none;
}
.el-cascader-menu__item{
    color: #666;
}
.el-cascader-menu__item.is-active{
    color: #666;
}
.el-cascader-menu__item:focus:not(:active), .el-cascader-menu__item:hover{
    background-color: #fbece4;
}
.el-cascader-menu__item:focus:not(:active){
    color: #fc8440;
}

// #newsunlamp{
//   height:100%;
// }
.el-popover{
    min-width: 80px;
}
.main{
// background: #fff;
min-width: 1260px;
max-width: 1920px;
height:100%;
margin: auto;
>.main_cont{
    height: calc(100% - 90px);
    overflow: auto;
}
header{
    .el-input__inner{
        background: #494e54;
        border:0px;
        color: #fff;
        font-size: 16px;
    }
    position: relative;
    min-width: 1260px;
    max-width: 1920px;
    margin: auto;
    .box{
        height: 90px;
    }
    .header_left{
        float: left;
        background: #373b44;
        color: #00d0ff;
        text-align: center;
        width: 160px;
        position: relative;
        .components_logo{
            cursor: pointer;
            position: absolute;
            width: 100%;
            top: 50%;
            margin-top: -25px;
            border-right: 1px solid rgba(255, 255, 255, 0.2);
            >img{
                height: 50px;
            }
        }
    }
    .header_centre{
        float: left;
        width: calc(100% - 160px);
// width: 91.3%;
font-size: 16px;
color: #222222;
display:flex;/*Flex布局*/
display: -webkit-flex; /* Safari */
align-items:center;/*指定垂直居中*/
>.notice_title{
    text-indent: 2em;
}
>.notice_title_width{
    width: calc(100% - 375px);
}
>div{
    width: calc(100% - 260px);
    height: 22px;
    overflow: hidden;
    position: relative;
    >div{
        text-indent: 1em;
        height: 22px;
        position: relative;
        white-space:nowrap;
        transition: all 1s;
    }
}
.el-cascader-menu__item--extensible:after{
    right:5px;
}
.el-cascader__label{
    color:#fff;
}
.is-disabled{
    .el-cascader__label{
        cursor: not-allowed;
    }
}
}
.header{
    float: left;
    width: calc(100% - 160px);
// width: 91.3%;
background: #373b44;
font-size: 16px;
color: #ffffff;
display:flex;/*Flex布局*/
display: -webkit-flex; /* Safari */
align-items:center;/*指定垂直居中*/
.el-cascader{
    margin-left: 40px;
}
>.notice_title{
    text-indent: 2em;
}
.noticeBox{
    width: calc(100% - 260px);
    height: 22px;
    overflow: hidden;
    position: relative;
    >div{
        text-indent: 1em;
        height: 22px;
        position: relative;
        white-space:nowrap;
        transition: all 1s;
    }
}
>.notice_title_width{
    width: calc(100% - 325px);
}
.el-cascader__label{
    color:#fff;
}
.is-disabled{
    .el-cascader__label{
        cursor: not-allowed;
    }
}
}
.header_right{
    position: absolute;
    right: 55px;
    .user_information{
        float: left;
        margin-top: 26px;
        .span1{
            display: block;
            max-width: 200px;
            font-size: 14px;
            color: #222222;
            cursor: pointer;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .span2{
            display: block;
            margin-top:2px;
            font-size: 12px;
            color: #6a8a9d;
        }

    }
    .user_image_div{
        float: left;
        cursor: pointer;
        margin: 24px 0 0 20px;
        padding: 0px;
        border: 0px;
        .user_image{
            width: 46px;
            height: 46px;
            background-size: 100% 100% !important;
            border-radius: 23px;
        }
    }
    .user_button{
        float: left;
        line-height:90px;
        cursor: pointer;
    }
}
.header_img_box{
    position: absolute;
    right: 55px;
    .user_information{
        float: left;
        margin-top: 26px;
        .span1{
            display: block;
            font-size: 14px;
            color: #fff;
            cursor: pointer;
        }
        .span2{
            display: block;
            margin-top:2px;
            font-size: 12px;
            color: #6a8a9d;
        }

    }
    .user_image_div{
        float: left;
        cursor: pointer;
        margin: 24px 0 0 20px;
        padding: 0px;
        border: 0px;
        background:#373b44;
        .user_image{
            width: 46px;
            height: 46px;
            background-size: 100% 100% !important;
            border-radius: 23px;
        }
    }
    .el-button:focus, .el-button:hover{
        background: #373b44;
    }
    .user_button{
        float: left;
        line-height:90px;
        cursor: pointer;
    }
}
}
}
}
.el-select-dropdown__item.selected{
    color: #fc8440;
}

@media screen and (max-width:1900px){
    body{
        .main{
            >.main_cont{
                height: calc(100% - 60px);
            }
            header{
                .box{
                    height: 60px;
                }
                .header_left{
                    .components_logo{
                        margin-top: -15px;
                        >img{
                            height: 30px;
                        }
                    }
                }
                .header_img_box{
                    .user_information{
                        margin-top: 10px;
                    }
                    .user_image_div{
                        margin: 10px 0 0 20px;
                        .user_image{
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
                .header_right{
                    .user_information{
                        margin-top: 10px;
                    }
                    .user_image_div{
                        margin: 10px 0 0 20px;
                        .user_image{
                            width: 40px;
                            height: 40px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue